import { brand } from '../../theme/tokens';

interface DKLogoProps {
  size?: number;
}

/** Two-heart monogram. SVG with brand gradient — matches design canvas. */
export function DKLogo({ size = 32 }: DKLogoProps) {
  const id = `dk-logo-grad-${size}`;
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" style={{ flexShrink: 0 }}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={brand.from} />
          <stop offset="100%" stopColor={brand.to} />
        </linearGradient>
      </defs>
      {/* back heart */}
      <path
        d="M21 15.5a4.5 4.5 0 0 1 7.6-3.2 4.5 4.5 0 0 1 0 6.4L23 24.3l-5.6-5.6a4.5 4.5 0 0 1 0-6.4 4.5 4.5 0 0 1 3.6-1.3z"
        fill={`url(#${id})`}
        opacity="0.55"
        transform="rotate(-12 23 19)"
      />
      {/* front heart */}
      <path
        d="M14 17a5 5 0 0 1 8.5-3.6 5 5 0 0 1 0 7.1L16 27l-6.5-6.5a5 5 0 0 1 0-7.1A5 5 0 0 1 14 17z"
        fill={`url(#${id})`}
        transform="rotate(8 16 21)"
      />
    </svg>
  );
}
